import { getAuth } from "firebase/auth";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import GetUser from "../../Controllers/Users/GetUser";

export default function RejectedVerificationViewModel() {
  const navigate = useNavigate();
  const auth = getAuth();
  const [AuthUserObject, setAuthUserObject] = useState({});

  useEffect(() => {
    async function fetchData() {
      const UserData = await GetUser(auth?.currentUser?.uid);
      console.log("UserData", UserData);
      setAuthUserObject(UserData);
    }
    fetchData();
  }, [auth?.currentUser?.uid]);

  return [navigate, AuthUserObject];
}
